// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Oqhzh","input":"styles_input__bcf6M"};